import { FormattedMessage } from 'react-intl';

import { DashboardCommissions } from '@components';

import './style.scss';

export function AgentCommissionsPage() {
  return (
    <div className="agent-commissions-page">
      <h1 className="agent-commissions-page__title">
        <FormattedMessage id="agent.commissions.title" />
      </h1>
      <p className="agent-commissions-page__subtitle">
        <FormattedMessage id="agent.commissions.subtitle" />
      </p>
      <DashboardCommissions />
    </div>
  );
}
